import { Directive, ElementRef } from '@angular/core';

@Directive({
    selector: '[bhWidgetToggle]'
})
export class BhWidgetToggleDirective
{
    /**
     * Constructor
     *
     * @param {ElementRef} elementRef
     */
    constructor(
        public elementRef: ElementRef
    )
    {
    }
}
